<template>
  <div class="bg-peach py-2 px-4 text-center text-14">
    <span>Kotiinkuljetukset -50% su 13.6 asti!</span>
  </div>
</template>
